<!-- Disabled: wrap the button in a span so the Bootstrap tooltip can fire on
     hover. Native disabled <button> elements don't dispatch hover events, so
     the tooltip must be attached to a hoverable wrapper. -->
<span
  *ngIf="isVisible && !isEnabled"
  class="d-inline-block transfer-borrower-button-wrapper"
  [appBsTooltip]="tooltip || ''"
  tabindex="0"
>
  <button
    type="button"
    class="btn btn-outline-secondary transfer-borrower-button"
    disabled
    [attr.aria-label]="tooltip"
  >
    Transfer Borrower Data
  </button>
</span>

<!-- Enabled: bare button, no tooltip wrapper needed. -->
<button
  *ngIf="isEnabled"
  type="button"
  class="btn btn-outline-secondary transfer-borrower-button"
  aria-label="Transfer Borrower Data"
  (click)="onClick()"
>
  Transfer Borrower Data
</button>
